import { MultilinkStoryblok } from "~/types/bloks";

const parametersList = ["category"];

export const getStoryblokUrl = (link: MultilinkStoryblok | undefined) => {
  if (link) {
    const url = link.url || link.cached_url;
    const parameters: [string, string][] = [];

    if (url) {
      let finalUrl = (() => {
        switch (link.linktype) {
          case "story":
            if (url === "/") {
              return "/";
            }

            return `/${url.replace(/\/$/g, "")}`;

          case "url":
            return url.replace(/\/$/g, "");

          case "asset":
            return url;
        }
      })();

      if (Object.keys(link).filter((k) => parametersList.includes(k)).length) {
        parametersList.forEach((p) => {
          if (link[p]) {
            parameters.push([p, link[p]]);
          }
        });

        finalUrl += `?${new URLSearchParams(parameters)}`;
      }

      if (link.anchor) {
        finalUrl += `#${link.anchor}`;
      }

      return finalUrl;
    }
  }

  return undefined;
};
